"use strict";

const IncidentInvestigationConstants = function () {
  var getNewIncidentInvestigationDefaults = function (incidentData) {
    const defaults = {
      fieldPersonnel: Session.loadContext().full_name,
      incidentId: incidentData.id,
      inspectionDate: DateTime.getTodayIso(),
      startTime: DateTime.getNowIso(),
      samplesCollected: false,
      followUpNeeded: false,
      closeOutInvestigation: false,
      locked: false,
      incidentInfo: incidentData,
    };

    if (incidentData.requestingType === "dry-weather-screen") {
      defaults.incidentType = incidentData.incidentType || "illicit-flow";
      defaults.reachedStormDrain = true;
    }

    if (incidentData.firstInvestigationType) {
      defaults.investigationType = "follow-up";
    } else {
      defaults.investigationType = "initial";
    }

    return defaults;
  };

  var getPrecipitationTypeOptions = function () {
    return FormSettings.getDropdownOptions("precipitation-type");
  };

  var getIncidentTypeOptions = function () {
    return FormSettings.getDropdownOptions("incident-type", { throwIfUndefined: false });
  };

  var getFilterIncidentTypeOptions = function () {
    const options = getIncidentTypeOptions();
    return [...options, { name: "Unknown", value: "unknown" }, { name: "No Data", value: "null" }];
  };

  var getIllicitFlowDescriptionOptions = function () {
    return FormSettings.getDropdownOptions("illicit-flow-description");
  };

  var getIllicitFlowMaterialActivityOptions = function () {
    const options = FormSettings.getDropdownOptions("illicit-flow-material-activity");
    Misc.pushOptionToEndOfArray(options, "other");
    return options;
  };

  var getSpillDescriptionOptions = function () {
    return FormSettings.getDropdownOptions("spill-description");
  };

  var getIllegalDumpingDescriptionOptions = function () {
    return FormSettings.getDropdownOptions("illegal-dumping-description");
  };

  var getIllicitActivityOptions = function () {
    const illegalDumpingDescriptionOptions = getIllegalDumpingDescriptionOptions() || [];
    const illicitFlowMaterialActivityOptions = getIllicitFlowMaterialActivityOptions() || [];

    return illicitFlowMaterialActivityOptions.concat(illegalDumpingDescriptionOptions);
  };

  var getIncidentTypeLocationOptions = function () {
    return FormSettings.getDropdownOptions("incident-type-location");
  };

  var getCleanLevelRequiredOptions = function () {
    return FormSettings.getDropdownOptions("clean-level-required", { sort: false });
  };

  var getCleanJurisdictionOptions = function () {
    return FormSettings.getDropdownOptions("clean-jurisdiction");
  };

  var getEnforcementLevelOptions = function () {
    return FormSettings.getDropdownOptions("enforcement-level");
  };

  var getCloseOutReasonOptions = function () {
    return FormSettings.getDropdownOptions("close-out-reason");
  };

  var getFilterCloseOutReasonOptions = function () {
    const options = getCloseOutReasonOptions();
    return [...options, { name: "No Data", value: "null" }];
  };

  var getFollowUpActionOptions = function () {
    return FormSettings.getDropdownOptions("follow-up-action");
  };

  var getIllicitSizeOptions1 = function () {
    const illicitSizeOptions1 = [
      {
        name: "cu-yds",
        value: "cubic-yards",
      },
    ];
    return illicitSizeOptions1;
  };

  var getIllicitSizeOptions2 = function () {
    const illicitSizeOptions2 = [
      {
        name: "cu-ft",
        value: "cubic-feet",
      },
      {
        name: "gallons",
        value: "gallons",
      },
    ];
    return illicitSizeOptions2;
  };

  var canAccessIncidentInvestigations = function (user) {
    return user.permissions.can_create_incident_investigation;
  };

  var getFollowUpInspectionTypeOptions = function () {
    return [
      {
        name: "Re-Investigation",
        value: "re-investigation",
      },
      {
        name: "Maintenance Notice",
        value: "maintenance-notice",
      },
    ];
  };

  var getInvestigationTypeOptions = function () {
    return FormSettings.getDropdownOptions("investigation-type", {
      tool: "idde",
      sort: false,
    });
  };

  return {
    getNewIncidentInvestigationDefaults,
    getIncidentTypeLocationOptions,
    getCleanJurisdictionOptions,
    getFollowUpActionOptions,
    getPrecipitationTypeOptions,
    getIncidentTypeOptions,
    getFilterIncidentTypeOptions,
    getIllicitFlowDescriptionOptions,
    getIllicitFlowMaterialActivityOptions,
    getSpillDescriptionOptions,
    getIllegalDumpingDescriptionOptions,
    getCleanLevelRequiredOptions,
    getEnforcementLevelOptions,
    getCloseOutReasonOptions,
    getFilterCloseOutReasonOptions,
    getIllicitSizeOptions1,
    getIllicitSizeOptions2,
    getIllicitActivityOptions,
    canAccessIncidentInvestigations,
    getFollowUpInspectionTypeOptions,
    getInvestigationTypeOptions,
  };
};

module.exports = IncidentInvestigationConstants();

const Session = require("../../login/session");
const DateTime = require("../../dateTime");
const FormSettings = require("../../settings/formSettings");
const Misc = require("../../misc.js");
